import { render } from "./TosPage.vue?vue&type=template&id=61fedd24"
import script from "./TosPage.vue?vue&type=script&lang=js"
export * from "./TosPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__